import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, VStack, Select, Button, Box } from '@chakra-ui/react'
import { useState, useEffect } from 'react'

interface MicrophoneSettingsModalProps {
  isOpen: boolean
  onClose: () => void
}

export function MicrophoneSettingsModal({ 
  isOpen, 
  onClose
}: MicrophoneSettingsModalProps) {
  const [error, setError] = useState<string | null>(null)

  const handleRefresh = () => {
    // Refresh the browser page
    window.location.reload()
  }

  useEffect(() => {
    if (isOpen) {
      setError(null)
    }
  }, [isOpen])

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent bg="#09090b" color="white">
        <ModalHeader>Microphone Settings</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <VStack spacing={4} align="stretch">
            <div>
              <div style={{ marginBottom: 8 }}>
                <div style={{ fontSize: '0.9em', color: '#A0AEC0', marginTop: 4 }}>
                  If the below refresh does not solve the problem, go into your browser's Settings, then Site Settings, and Allow Microphone use.
                </div>
              </div>
            </div>

            <Box display="flex" justifyContent="center">
              <Button 
                size="sm" 
                colorScheme="blue" 
                onClick={handleRefresh} 
                w="30%"
              >
                Refresh
              </Button>
            </Box>

            {error && (
              <div style={{ color: '#F56565', fontSize: '0.9em' }}>{error}</div>
            )}
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
} 